/** Mercado SaaS do painel (doc 13 § 14) — catálogo BRL vs USD. */

export const ADATIS_MARKET_STORAGE_KEY = "adatis.market";

export type AdatisMarket = "br" | "global";

const normalizeMarket = (value: string | null | undefined): AdatisMarket | null => {
  const normalized = (value || "").trim().toLowerCase();

  if (normalized === "global" || normalized === "br") {
    return normalized;
  }

  return null;
};

/**
 * Resolve o mercado enviado em `X-Adatis-Market`.
 *
 * Prioridade (SPA):
 * 1. Host `adatis.app` / `*.adatis.app` → sempre `global`
 * 2. Query `?market=` ou `?adatis_market=` (`br`|`global`) — smoke; persiste em localStorage
 * 3. localStorage `adatis.market=global`
 * 4. Fallback `br`
 *
 * A API ainda aplica o gate `ADATIS_GLOBAL_MARKET_PUBLIC` /
 * `ADATIS_SAAS_PADDLE_SANDBOX_CHECKOUT` — override no painel `.com.br` só
 * funciona com sandbox checkout ligado (doc 08 § 3.1.2).
 */
export const resolveAdatisMarket = (): AdatisMarket => {
  if (typeof window === "undefined") {
    return "br";
  }

  const host = window.location.hostname.toLowerCase();

  if (host === "adatis.app" || host.endsWith(".adatis.app")) {
    return "global";
  }

  try {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = normalizeMarket(
      params.get("market") || params.get("adatis_market")
    );

    if (fromQuery === "global") {
      localStorage.setItem(ADATIS_MARKET_STORAGE_KEY, "global");
      return "global";
    }

    if (fromQuery === "br") {
      localStorage.removeItem(ADATIS_MARKET_STORAGE_KEY);
      return "br";
    }
  } catch {
    // URLSearchParams / localStorage indisponível
  }

  try {
    if (normalizeMarket(localStorage.getItem(ADATIS_MARKET_STORAGE_KEY)) === "global") {
      return "global";
    }
  } catch {
    // localStorage indisponível
  }

  return "br";
};
